module.exports = __webpack_public_path__ + "static/img/page1.efaa0ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/page1.png
// module id = wZJD
// module chunks = 2